import { SHDotGroup, SHHtmlBlock, SHStack } from "@components/design-systems";
import { useInputDotIndicator } from "@hooks/useInvestmentProduct";
import { InvestmentProductEsgDTO } from "@models/product/investment-product/entities/esg";
import { useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { getEditESGSectionDataPath } from "../../util";

export const EditESGSectionTitle = ({
  title,
  subTitle,
  icon,
  postfixLabel,
  sectionIndex,
}: {
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  icon?: React.ReactNode;
  postfixLabel?: React.ReactNode;
  sectionIndex: number;
}) => {
  const { palette } = useTheme();

  const { control, getValues } = useFormContext<InvestmentProductEsgDTO>();

  const sectionDataPath = useMemo(
    () => getEditESGSectionDataPath(sectionIndex),
    [sectionIndex],
  );
 
  const { isShowOrangeDot, isShowBlueDot } =
    useInputDotIndicator<InvestmentProductEsgDTO>({
      getValues,
      control,
      paths: {
        highlightType: sectionDataPath.highlightType,
        dataStatus: sectionDataPath.dataStatus,
      },
    });

  return (
    <SHStack>
      <SHStack direction="row" spacing={1} alignItems="center">
        {icon}
        <SHStack direction="row" spacing={0.5} alignItems="start">
          {typeof title === "string" ? (
            <SHHtmlBlock
              variant={"subtitle2"}
              textAlign={"left"}
              content={title}
            />
          ) : (
            title
          )}
          <SHDotGroup
            blueDot={isShowBlueDot}
            orangeDot={isShowOrangeDot}
            paddingTop={"5px"}
          />
        </SHStack>
        <SHStack direction="row" spacing={1} alignItems="center" pb={"5px"}>
          {postfixLabel}
        </SHStack>
      </SHStack>
      {typeof subTitle === "string" ? (
        <SHHtmlBlock
          variant="body4"
          color={palette.text.third}
          content={subTitle}
        />
      ) : (
        subTitle
      )}
    </SHStack>
  );
};
